import React, { FunctionComponent } from 'react';

const PauseIcon: FunctionComponent = () => (
  <svg className="w-10 fill-current xl:w-12" viewBox="0 0 10 12">
    <path
      fillRule="evenodd"
      d="M8,0 L8,12 L6,12 L6,0 L8,0 Z M2,0 L2,12 L0,12 L0,0 L2,0 Z"
      transform="translate(1)"
    />
  </svg>
);

export default PauseIcon;
